import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/pages/MainPage.vue'

const routes = [
  {
    path: '/',
    redirect: '/auth0'
  },
  {
    path: '/auth0',
    name: 'home',
    component: HomeView
  },

]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
